export const motionEase = [0.22, 1, 0.36, 1] as const;

export const uiSpring = {
  type: "spring" as const,
  stiffness: 430,
  damping: 38,
  mass: 0.78,
};

export const panelSpring = {
  type: "spring" as const,
  stiffness: 280,
  damping: 32,
  mass: 0.94,
};

export const softSpring = {
  type: "spring" as const,
  stiffness: 220,
  damping: 30,
  mass: 1.05,
};

export const staggerContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.045,
      delayChildren: 0.04,
    },
  },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 8, filter: "blur(4px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: softSpring,
  },
};
